<template name="Time">
  <div>
    <van-overlay :show="TimeControlShow">
      <!-- 'animationStart': !startControlShow,'startTimeContainer':startControlShow -->
      <div
        v-bind:class="{'animationStart': !startControlShow,'startTimeContainer':startControlShow}"
      >
        <van-datetime-picker
          v-show="startControlShow"
          v-model="currentDate"
          type="datetime"
          title="选择出发时间段"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="filter"
          @confirm="startConfirm"
          @cancel="startCcancel"
        />
      </div>
      <div
        v-bind:class="{'animationStart': startControlShow,'startTimeContainer':!startControlShow}"
      >
        <van-datetime-picker
          v-show="!startControlShow"
          v-model="currentTime"
          type="time"
          title="选择结束时间段"
          :formatter="filter"
          :min-hour="endMinHour"
          :max-hour="endMaxHour"
          :min-minute='endMixMinute'
          @confirm="endConfirm"
          @cancel="startCcancel"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { minDateTimeFun, formattingTime } from "@/utils/public.js";
export default {
  name:"Time",
  props: {
    TimeControlShow: {
      type: Boolean
    },
	plusMinutes:{ //数据格式
		type:Number,
		required:false
	}
  },
  data() {
    return {
      show: true,
      minDate: minDateTimeFun("", this.plusMinutes),
      maxDate: minDateTimeFun("maxDate"),
      currentDate: new Date(),
      endMinHour: 0,
      endMaxHour: 23,
      endMixMinute:0,
      maxMinute:59,
      currentTime: "00:00",
      startControlShow: true, //出发时间显示
      userTimeObj: null //传递给父组件的值
    };
  },
  methods: {
    startConfirm(value) {
      let time = formattingTime("day:MM:dd", value);
      if (time.hours === 23||time.hours===22) {
        this.endMinHour = time.hours;
        this.endMixMinute = time.minutes
      } else {
         //this.endMixMinute = 0
        //this.endMinHour = time.hours+2;
		console.log('time', time);
		var t = Number(time.minutes) + 20;
		var h = time.hours;
		console.log('th1', t, h);
		if(t > 59) {
			t = t - 60;
			h = h + 1;
		}
		console.log('th2', t, h);
		this.endMixMinute = t;
		this.endMinHour = h;
      }
      this.startControlShow = false;
      this.userTimeObj = time;
    },
    startCcancel() {
      this.startControlShow = true;
      this.$emit("childTimeCancel", false);
    },
    endConfirm(value) {
      console.log('endHour',value);
      this.userTimeObj.endHour = value;
      this.userTimeObj.state = false;
      this.startControlShow = true;
      this.$emit("childTimeFun", this.userTimeObj);
    },
    filter(type, val) {
      if (type === "year") {
        return [`${val}年`];
      }
      if (type === "month") {
        return `${val}月`;
      }
      if (type === "day") {
        return `${val}日`;
      }
      if (type === "hour") {
        return `${val}时`;
      }
      if (type === "minute") {
        return `${val}分`;
      }
      return val;
    }
  }
};
</script>
<style lang="scss" scoped>
.van-overlay {
  z-index: 20;
}

@keyframes Mymove {
  from {
    bottom: -800px;
  }
  to {
    bottom: 0;
  }
}
@keyframes MymoveEnd {
  from {
    position: fixed;
    bottom: 0;
  }
  to {
    position: fixed;
    bottom: -800px;
  }
}

.startTimeContainer {
  .van-picker {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    animation: Mymove 0.5s;
  }
}
.animationStart {
  position: fixed;
  right: 0;
  left: 0;
  bottom: -800px;
  animation: MymoveEnd 0.5s;
}

.endTimeContainer {
  .van-picker {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
  }
}
</style>